<template>
  <div>
    <v-app-bar
        outlined
        flat
        color="white"
        height="52px"
        style="border-bottom: 1px solid #EDEDED !important;"
    >
      <IconTooltipButtonBottom
          icon="mdi-arrow-left"
          tooltip="Zurück zur Liste"
          id="default"
          width="50px"
          large
          @click="$router.go(-1)"
      />      <v-spacer></v-spacer>
      <v-toolbar-title>
        <v-chip outlined color="gray_3" text-color="gray" class="mr-2">{{decodeModuleNameByEnum(survey.module)
          }}</v-chip>
        {{survey.title}}
        <v-chip label :color="parseStateColor(survey.info.state)+'_s'"
                :text-color="parseStateColor(survey.info.state)"
                class="ml-2">{{ parseSurveyState(survey.info.state) }}</v-chip>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-card flat class="px-layout max-height">
      <div v-if="evaluationLoaded" class="pa-10">
        <v-row>
          <v-col class="survey-title">
            <h1>Auswertung der Umfrage</h1>
            <h2>{{survey.title}}</h2>
          </v-col>
          <v-col class="d-flex flex-row justify-end">
            <v-card v-if="evaluations.length > 1" flat class="evaluation-info">
              <v-card-title class="evaluation-info-title">Wiederholt verschickt</v-card-title>
              <span class=evaluation-info-text>{{ evaluations.length }}</span>
            </v-card>
            <v-card flat class="evaluation-info">
              <v-card-title class="evaluation-info-title">Zuletzt gestellt</v-card-title>
              <span class=evaluation-info-text>{{ compareEvaluation.timestamp ?
                  timeConverter(compareEvaluation.timestamp) : timeConverter(survey.createdDate) }}</span>
            </v-card>
            <v-card flat class="evaluation-info">
              <v-card-title class="evaluation-info-title">Abgeschlossen</v-card-title>
              <span class=evaluation-info-text>{{ survey.deadlineDate ? timeConverter(survey.deadlineDate) :
                  timeConverter(currentEvaluation.timestamp)
                }}</span>
            </v-card>
            <v-card flat class="evaluation-info">
              <v-card-title class="evaluation-info-title">Teilnehmeranzahl</v-card-title>
              <span class=evaluation-info-text>{{ currentEvaluation.numberCompleteAnswered }}</span>
            </v-card>
          </v-col>
        </v-row>
        <v-row style="width: 100%;">
          <v-tabs v-model="currentTab" color="secondary">
            <v-tooltip bottom v-for="tab in tabs" :key="tab" max-width="600" open-delay="400">
              <template v-slot:activator="{ on, attrs }">
                <v-tab  id="tab"
                        :key="tab.key"
                        :href="'#'+tab.key"
                        @click="hideTreeDetails()"
                        v-bind="attrs" v-on="on"
                >
                  {{ tab.name }}
                  <v-spacer/>
                </v-tab>
              </template>
              <span>{{ tab.description }}</span>
            </v-tooltip>
          </v-tabs>
        </v-row>
        <v-row class="full-width ma-0">
          <div v-model="currentTab" class="full-width">
            <div v-if="currentTab=='outcome' && currentModule == 1" class="all">
              <h2 class="px-3 mt-8">{{decodeModuleNameByNumberForEvaluation(1.1)}}</h2>
              <v-row class="row1 mt-0">
                <v-col v-for="(ev, index) in currentEvaluation.node.filter(node => node.node.nodeType == 'OUTCOME')"
                     :key="ev.id" cols="3">
                  <v-card id="card" flat :class="'bg-gray tree-'+index">
                    <v-card-title id="cardTitle" class="ma-0 pa-0 px-5"><h3>{{ ev.node.name }}</h3></v-card-title>
                    <v-divider id="divider"/>
                    <div id="circleFrame">
                      <vue-ellipse-progress
                              id="circle"
                              :progress=100
                              :thickness=10
                              :size=125
                              :color="getColor(ev.score)"
                      >
                        <template v-slot:default="{ data }">
                          <span style="font-size: 2.5rem; line-height: 1.5rem; color:
                              var(--v-secondary-base);"
                              class="numeric">
                            {{ ev.score }}
                          </span>
                        </template>
                      </vue-ellipse-progress>
                      <v-col class="trend-test">
                  <span class="d-flex align-center align-content-center">
                        <div class="svg-container">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.9367 13.5C10.9117 13.5 10.1073 11.151 9.32941 8.87963C8.59253 6.72638 7.82922 4.5 6.18672 4.5C5.8032 4.52255 5.43508 4.65876 5.12925 4.89126C4.82341 5.12377 4.59371 5.44205 4.46941 5.80556L3.40234 5.44725C3.43103 5.36287 4.11728 3.375 6.18672 3.375C8.63359 3.375 9.56847 6.10594 10.3942 8.51512C11.0743 10.5002 11.7161 12.375 12.9367 12.375C13.3202 12.3524 13.6884 12.2162 13.9942 11.9837C14.3 11.7512 14.5297 11.433 14.654 11.0694L15.7205 11.4277C15.6924 11.5121 15.0062 13.5 12.9367 13.5Z" fill="#2E2E2E"/>
                            <path d="M2.25 15.75V9.5625H3.375V8.4375H2.25V1.125H1.125V15.75C1.125 16.0484 1.24353 16.3345 1.4545 16.5455C1.66548 16.7565 1.95163 16.875 2.25 16.875H16.875V15.75H2.25Z" fill="#C9C9C9"/>
                            <path d="M4.5 8.4375H5.625V9.5625H4.5V8.4375ZM6.75 8.4375H7.875V9.5625H6.75V8.4375ZM11.25 8.4375H12.375V9.5625H11.25V8.4375ZM13.5 8.4375H14.625V9.5625H13.5V8.4375ZM15.75 8.4375H16.875V9.5625H15.75V8.4375Z" fill="#C9C9C9"/>
                          </svg>
                        </div>
                        <h6 class="text-uppercase" style="font-size: 10px; font-weight: 600; vertical-align: center;
                        line-height: 18px;">
                          Trend</h6>
                      </span>
                        <div @click="showTrendDetails('trendDetail_', index)"
                             class="bg-white px-4 py-2 d-flex justify-space"
                             style="cursor: pointer;">
                          <div class="trend-left">
                            <v-chip label :color="getTrendColor(getTrend(ev, index))+'_s'"
                                    :text-color="getTrendColor(getTrend(ev, index))">

                            <span v-if="getTrend(ev, index) != 0"
                                  class="numeric font-l font-weight-bold"> {{ getTrend(ev, index) }}
                      </span>
                              <v-icon medium>{{ getTrendIcon(getTrend(ev, index)) }}</v-icon>
                            </v-chip>
                            <span style="font-size: 12px;" class="ml-2"
                                  :class="getTrend(ev, index) == 0 ? 'text--disabled' : 'text--secondary'">{{
                                getTrendText(getTrend(ev,
                                    index))
                              }}</span>
                          </div>

                          <v-icon style="font-size: 2vmin;">mdi-unfold-more-horizontal</v-icon>
                        </div>
                        <span @click="showTreeDetails('treeDetails_', index)"
                              class="card-detail pointer mt-4 float-right font-weight-medium">Details
                          ansehen
                        </span>
                      </v-col>
                    </div>
                  </v-card>
                  <v-card flat class="tree-menu__container bg-gray" style="visibility: hidden;">
                    <div class="tree-menu">
                      <tree-menu :label="ev.node.name" :nodes="ev.children" :depth=1 :score="ev.score"
                                 :eventBus="eventBus" :ref="'treeDetails_'+index"/>
                    </div>
                  </v-card>
                  <PXSurveyEvaluationTrendDetail 
                    :ev="ev" :index="index"
                    :label="ev.node.name"
                    :score="ev.score"
                    :timestamp="currentEvaluation.timestamp"
                    :timeConverter="timeConverter"
                    :getTrend="getTrend"
                    :getTrendColor="getTrendColor"
                    :getTrendIcon="getTrendIcon"
                    :getTrendText="getTrendText"
                    :getEvaluationsForTrend="getEvaluationsForTrend"
                    :ref="'trendDetail_'+index"/>

                </v-col>
              </v-row>
            </div>
            <div v-if="currentTab=='all'" class="all">
              <h2 class="px-3 mt-8">{{decodeModuleNameByNumberForEvaluation(currentModule)}}</h2>
              <v-row class="row1 mt-0">
                <v-col v-for="(ev, index) in currentEvaluation.node.filter(node => node.node.nodeType != 'OUTCOME')"
                     :key="ev.id">
                  <v-card id="card" flat :class="'bg-gray tree-'+index">
                    <v-card-title id="cardTitle" class="ma-0 pa-0 px-5"><h3>{{ ev.node.name }}</h3></v-card-title>
                    <v-divider id="divider"/>
                    <div id="circleFrame">
                      <vue-ellipse-progress
                              id="circle"
                              :progress=100
                              :thickness=10
                              :size=125
                              :color="getColor(ev.score)"
                      >
                        <template v-slot:default="{ data }">
                          <span style="font-size: 2.5rem; line-height: 1.5rem; color:
                              var(--v-secondary-base);"
                              class="numeric">
                            {{ ev.score }}
                          </span>
                        </template>
                      </vue-ellipse-progress>
                      <v-col class="trend-test">
                  <span class="d-flex align-center align-content-center">
                        <div class="svg-container">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.9367 13.5C10.9117 13.5 10.1073 11.151 9.32941 8.87963C8.59253 6.72638 7.82922 4.5 6.18672 4.5C5.8032 4.52255 5.43508 4.65876 5.12925 4.89126C4.82341 5.12377 4.59371 5.44205 4.46941 5.80556L3.40234 5.44725C3.43103 5.36287 4.11728 3.375 6.18672 3.375C8.63359 3.375 9.56847 6.10594 10.3942 8.51512C11.0743 10.5002 11.7161 12.375 12.9367 12.375C13.3202 12.3524 13.6884 12.2162 13.9942 11.9837C14.3 11.7512 14.5297 11.433 14.654 11.0694L15.7205 11.4277C15.6924 11.5121 15.0062 13.5 12.9367 13.5Z" fill="#2E2E2E"/>
                            <path d="M2.25 15.75V9.5625H3.375V8.4375H2.25V1.125H1.125V15.75C1.125 16.0484 1.24353 16.3345 1.4545 16.5455C1.66548 16.7565 1.95163 16.875 2.25 16.875H16.875V15.75H2.25Z" fill="#C9C9C9"/>
                            <path d="M4.5 8.4375H5.625V9.5625H4.5V8.4375ZM6.75 8.4375H7.875V9.5625H6.75V8.4375ZM11.25 8.4375H12.375V9.5625H11.25V8.4375ZM13.5 8.4375H14.625V9.5625H13.5V8.4375ZM15.75 8.4375H16.875V9.5625H15.75V8.4375Z" fill="#C9C9C9"/>
                          </svg>
                        </div>
                        <h6 class="text-uppercase" style="font-size: 10px; font-weight: 600; vertical-align: center;
                        line-height: 18px;">
                          Trend</h6>
                      </span>
                        <div @click="showTrendDetails('trendDetail_', index)"
                             class="bg-white px-4 py-2 d-flex justify-space"
                             style="cursor: pointer;">
                          <div class="trend-left">
                            <v-chip label :color="getTrendColor(getTrend(ev, index))+'_s'"
                                    :text-color="getTrendColor(getTrend(ev, index))">

                            <span v-if="getTrend(ev, index) != 0"
                                  class="numeric font-l font-weight-bold"> {{ getTrend(ev, index) }}
                      </span>
                              <v-icon medium>{{ getTrendIcon(getTrend(ev, index)) }}</v-icon>
                            </v-chip>
                            <span style="font-size: 12px;" class="ml-2"
                                  :class="getTrend(ev, index) == 0 ? 'text--disabled' : 'text--secondary'">{{
                                getTrendText(getTrend(ev,
                                    index))
                              }}</span>
                          </div>

                          <v-icon style="font-size: 2vmin;">mdi-open-in-new</v-icon>
                        </div>
                        <span @click="showTreeDetails('treeDetails_', index)"
                              class="card-detail pointer mt-4 float-right font-weight-medium">Details
                          ansehen
                        </span>
                      </v-col>
                    </div>
                  </v-card>
                  <v-card flat class="tree-menu__container bg-gray" style="visibility: hidden;">
                    <div class="tree-menu">
                      <tree-menu :label="ev.node.name" :nodes="ev.children" :depth=1 :score="ev.score"
                                   :eventBus="eventBus" :ref="'treeDetails_'+index"/>
                    </div>
                  </v-card>
                  <PXSurveyEvaluationTrendDetail 
                    :ev="ev" :index="index"
                    :label="ev.node.name"
                    :score="ev.score"
                    :timestamp="currentEvaluation.timestamp"
                    :timeConverter="timeConverter"
                    :getTrend="getTrend"
                    :getTrendColor="getTrendColor"
                    :getTrendIcon="getTrendIcon"
                    :getTrendText="getTrendText"
                    :getEvaluationsForTrend="getEvaluationsForTrend"
                    :ref="'trendDetail_'+index"/>

                </v-col>
              </v-row>
            </div>
            <div v-if="currentTab=='statistic'" class="statistic full-width pl-4 mt-8">
              <div class="border-10 border-1 d-flex flex-column full-width">
                <div class="statistic__header border-bottom px-10">
                  <h2>Statistiken der Umfrage</h2>
                </div>
                <div class="statistic__main d-flex flex-row full-width" style="width: 80vw; min-height: 40vh;">
                  <ul class="border-right pa-0 ma-0" style="width: 16vw;">
                    <li key="reaction" class="statistic__main__menu mt-10 pl-6" :class="currentStatisticTab ==
                    'reaction' ?
                    'statistic__main__menu--active' : ''"
                        @click="changeStatisticTab('reaction')">
                      <span></span>Reaktion<span></span>
                    </li>
                    <li key="volume" class="statistic__main__menu pl-6" :class="currentStatisticTab == 'volume' ?
                    'statistic__main__menu--active' : ''" @click="changeStatisticTab('volume')">
                      <span></span>Reaktionsvolumen <span></span>
                    </li>
                  </ul>
                  <div class="statistic__main__right px-10 py-10 full-width">
                    <div v-if="currentStatisticTab == 'reaction'" class="statistic__reaction">
                      <h3>Reaktion</h3>
                      <span class="mr-8">Beantwortet: {{survey.info.answeredCount}}</span>
                      <span>Noch nicht beantwortet: {{survey.info.sendToCount - survey.info.answeredCount}}</span>
                      <div class="statistic__reaction__chart">
                        <v-row v-for="elem in selectedEvaluation.questionEvaluations" :key="elem" >
                          <v-btn color="primary" elevation="0" v-for="chart in chartTypes" :key="chart.name" @click="elem.chartType = chart.type">
                            {{chart.name}}
                          </v-btn><br/>
                          <v-card flat id="surveyCard">
                            <v-card-title>{{elem.questionText}}</v-card-title>
                            <BarChart v-if="elem.chartType == 'BAR'" :data="elem"/>
                            <DoughnutChart v-if="elem.chartType == 'CIRCLE'" :data="elem"/>
                          </v-card>
                        </v-row>
                      </div>
                    </div>
                    <div v-if="currentStatisticTab == 'volume'" class="statistic__volume">
                      <!-- <v-menu
                          ref="datePicker"
                          v-model="datePicker"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span>{{ dates }}</span>
                          <v-icon small v-model="date"
                                  v-bind="attrs"
                                  v-on="on">mdi-pencil</v-icon>
                        </template>
                        <v-date-picker
                            v-model="date"
                            range
                            no-title
                            scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="datePicker = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.datePicker.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu> -->
                      <div class="statistic__volume__chart">
                        <ReactionChart :data="getReaction()"/>
                        <!-- <v-row v-for="elem in selectedEvaluation.questionEvaluations" :key="elem" >
                          <v-btn color="primary" elevation="0" v-for="chart in chartTypes" :key="chart.name" @click="elem.chartType = chart.type">
                            {{chart.name}}
                          </v-btn><br/>
                          <v-card id="surveyCard">
                            <v-card-title>{{elem.questionText}}</v-card-title>
                            <BarChart v-if="elem.chartType == 'BAR'" :data="elem"/>
                            <DoughnutChart v-if="elem.chartType == 'CIRCLE'" :data="elem"/>
                          </v-card>
                        </v-row> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentTab=='personalQuestions'" value="personalQuestions" class="full-width pl-4 mt-8">
              <div class="border-10 border-1 ">
                <div class="statistic__header border-bottom px-10">
                  <h2>Personenbezogene Fragen</h2>
                </div>
                <div class="full-width">
                  <v-row>
                    <v-col cols="12" sm="3" md="4" v-for="(elem, index) in personalEvaluations" :key="index" >
                      <PersonalQuestionTile :personalEval="elem" />
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </v-row>
       
      </div>
    </v-card>
    <v-progress-linear
        v-if="loadingProgress !== 100"
        style="position: fixed; bottom: 0; left: 0; z-index: 99;"
        color="gray"
        :indeterminate="loadingProgress == 100 ? false : true"
        height="5"
        :value="loadingProgress"
    ></v-progress-linear>
    <PXSurveyEvaluationQuestionDetail ref="questionEvalDetail"/>
  </div>
</template>

<script>
import Vue from 'vue';
import { VueEllipseProgress } from "vue-ellipse-progress";
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import surveyEvaluationService from '@/components/surveyEvaluationService'
import IconTooltipButtonBottom from '@/components/common/IconTooltipButtonBottom.vue'
import pxSurveyService from '../px-survey-service';
import TreeMenu from './PXSurveyEvaluationTreeMenu.vue';

import BarChart from "./Charts/BarChart.vue";
import DoughnutChart from "./Charts/DoughnutChart.vue";
import ReactionChart from './Charts/ReactionChart.vue';
import LineChart from './Charts/LineChart.vue';
import PXSurveyEvaluationTrendDetail from './PXSurveyEvaluationTrendDetail.vue';
import PXSurveyEvaluationQuestionDetail from './PXSurveyEvaluationQuestionDetail.vue';
import PersonalQuestionTile from './PersonalQuestionTile.vue';
import {decodeModuleNameByEnum, decodeModuleNameByNumberForEvaluation} from '@/components/util.js'
export default {
  components: {
    LoadingOverlay,
    VueEllipseProgress,
    TreeMenu,
    BarChart,
    DoughnutChart,
    ReactionChart,
    LineChart,
    PXSurveyEvaluationTrendDetail,
    PXSurveyEvaluationQuestionDetail,
    PersonalQuestionTile,
    IconTooltipButtonBottom
},
  props:{
    surveyIdProp: String
  },  
  data: () => ({
    currentTab: 'all',
    tabs: [],
    expanded: [],
    average: true,
    questionHeaders: [
      { text: 'Nr.', value: 'index', width: '32px', },
      {
        text: 'Fragen',
        align: 'start',
        sortable: true,
        value: 'question.questionText',
        width: '72%',
      },
      { text: 'Durchschnittswert', value: 'averageRate' },
      { text: 'Ergebnis', value: 'averageAnswer', width: '10%' },
      { text: '', value: 'data-table-expand' },
    ],
    currentStatisticTab: 'reaction',
    evaluations: [],
    surveyId: null,
    chartTypes: [
      {name: "Kreisdiagramm", type:"CIRCLE"},
      {name: "Balkendiagramm", type:"BAR"}
    ],
    currentEvaluation: null,
    compareEvaluation: null,
    evaluationLoaded: false,
    loadingProgress: 0,
    questionEvaluation: false,
    selectedEvaluation: {},
    survey: null,
    matrixValues: {
          value: 1,
          1: "Trifft überhaupt nicht zu",
          2: "Trifft nicht zu",
          3: "Trifft eher nicht zu",
          4: "Trifft eher zu",
          5: "Trifft zu",
          6: "Trifft voll und ganz zu"
    },
    eventBus: new Vue(),
    personalEvaluations: null,
    currentModule: 0
    // showCardDetails: false,
  }),
  computed:{
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    outcomeElements(){
      return this.currentEvaluation.node.filter(elem => elem.node.nodeType == 'OUTCOME');
    }
  },
  watch:{
    average(){
      this.expanded = [];
    }
  },  
  mounted(){
    this.eventBus.$on('evaluateQuestion', data => {
      this.handleEvaluateQuestion(data);
    })

    if(this.$route.params.surveyId != null){
      this.surveyId = this.$route.params.surveyId;
    }else{
      this.surveyId = this.surveyIdProp;
    }
    pxSurveyService.retrieveSingleSurvey(this.surveyId).then(res => {
      this.survey = res.data;
      if(this.survey.module == "Module_Two"){
        this.fetchEvaluations(2);
        this.currentModule = 2;
        this.tabs = [
          {name: decodeModuleNameByNumberForEvaluation(2), key: 'all', description: 'Übersicht über die Gesamtauswertung'},
          {name: 'Reaktion', key: 'statistic', description: 'Übersicht über Zeitpunkte und offene Umfragen'},
        ]
      }else if(this.survey.module == "Module_One"){
        this.tabs = [
          {name: decodeModuleNameByNumberForEvaluation(1.1), key: 'outcome', description: ' Bei dem „Stimmungsbild der Beschäftigten“ können Sie sehen, wie hoch die Arbeitszufriedenheit, Arbeitseffizienz und Betriebsbindung der Beschäftigten ist. Die Werte ergeben sich aus der Beschäftigtenumfrage und werden nach dem Schulnotensystem ausgewertet. 1 bedeutet daher „sehr gut“ und 6 „ungenügend“'},
          {name: decodeModuleNameByNumberForEvaluation(1), key: 'all', description: 'Hier sehen Sie, ob die Beschäftigten in den Kategorien Arbeitsaufgabe, Arbeitsbedingung, Arbeitsrolle, Personensystem und soziales Umfeld Stressoren oder Ressourcen wahrnehmen. Diese 5 Bereiche haben jeweils Unterbereiche. Detaillierte Informationen darüber erhalten Sie, indem Sie die Kategorien anklicken. Stressoren sind andauernde physische oder psychische Aufwände und erfordern daher bestimmte Fähigkeiten von berufstätigen Personen, sodass sie Kosten darstellen. Im Gegensatz dazu ermöglichen Ressourcen, Arbeitsziele zu erreichen, arbeitsbedingten Belastungen und damit einhergehenden physischen und psychischen Kosten entgegenzuwirken sowie persönliches Wachstum, Lernen und Entwicklung anzustoßen. Es wird abgestrebt, dass die Ressourcen die Stressoren überwiegen. Die Werte ergeben sich aus der Beschäftigtenumfrage und werden nach dem Schulnotensystem ausgewertet. 1 bedeutet daher „sehr gut“ und 6 „ungenügend.'},
          {name: 'Reaktion', key: 'statistic', description: 'Übersicht über Zeitpunkte und offene Umfragen'},
        ]
        this.fetchEvaluations(1);
        this.currentModule = 1;
      }else if(this.survey.module == "STRESS_MODULE"){
        this.tabs = [
          {name: decodeModuleNameByNumberForEvaluation(5), key: 'all', description: 'Übersicht über die Gesamtauswertung'},
          {name: 'Reaktion', key: 'statistic', description: 'Übersicht über Zeitpunkte und offene Umfragen'},
        ]
        this.fetchEvaluations(5);
        this.currentModule = 5;
      }
    });

  },
  methods:{
    decodeModuleNameByNumberForEvaluation:decodeModuleNameByNumberForEvaluation,
    decodeModuleNameByEnum: decodeModuleNameByEnum,
    getQuestionsEvaluations(){
      let questionEvaluations = [];
      let questions = [];
      if(this.average){
        questions = this.evaluations.map( (e) => ({
          timestamp : e.timestamp, 
          questionEvaluations : e.questionEvaluations
        }));
      }else{
        questions = [{
          timestamp : this.evaluations[this.evaluations.length-1].timestamp, 
          questionEvaluations : this.evaluations[this.evaluations.length-1].questionEvaluations
        }];
      }
      questions.forEach(e => {
        e.questionEvaluations.forEach((ev, index) => {
          if(questionEvaluations.some(s => s.question.questionId == ev.questionId)){
            let elem = questionEvaluations.filter(s => s.question.questionId == ev.questionId)[0];
            elem.evalData.push({
              timestamp: e.timestamp,
              scores: ev.scores,
              // averageRate: this.getAverageRate(ev.scores),
            })
          }else{
            questionEvaluations.push({
              question: ev,
              evalData: [{
                timestamp: e.timestamp,
                scores: ev.scores
              }],
              averageRate: this.getAverageRate(ev.scores),
              averageAnswer: this.getAverageAnswer(ev.scores),
              index: index + 1,
              showTreeDetails: false,
            })
          }
        })
      })
      return questionEvaluations;
    },
    getReaction(){
      let reactions = [];
      this.evaluations.forEach(ev => {
        reactions.push({
          timestamp: ev.timestamp,
          completed: ev.numberCompleteAnswered,
          empty: ev.numberNotAnswered,
          partial: ev.numberPartiallyAnswered
        })
      })
      return reactions;
    },
    getScore(item, scoreVal){
      let score = 0;
      let evals = item.evalData.map(e => e.scores);
      evals.forEach(elem => score += elem[scoreVal]);
      return score;
    },
    calcPercentageScore(item, scoreVal){
      let score = 0;
      let scoreCount = 0;
      let evals = item.evalData.map(e => e.scores);
      evals.forEach(elem => {
        score += elem[scoreVal];
        scoreCount += Object.values(elem).reduce((a, b) => a + b)
      });
      return (100*(score/scoreCount)).toFixed(2);
    },
    fetchEvaluations(module){
      this.selectedEvaluation = {};
      this.evaluation = [];
      surveyEvaluationService.retrieveTimestampEvaluationsForSurvey(this.surveyId, module).then(res => {
        this.evaluations = res.data;
        this.evaluations.forEach(elem => {
          if(elem.node == null) return;
          let nodes = [];
          elem.node.forEach(e => {
          e.node.parent = null;
          e.showDetails = false;
          this.remodelEvalObject(e);
          nodes.push(e);
          });
          elem.node = nodes;
        })
        this.evaluations.forEach(e => {
          if(e.questionEvaluations != null){
            e.questionEvaluations.forEach(e => Vue.set(e, 'chartType', 'BAR'));
          }
          e.node = e.node.sort((a,b) => {
            let textA = a.node.name.toUpperCase();
            let textB = b.node.name.toUpperCase();
            return  (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          })
        })
        this.currentEvaluation = this.evaluations[this.evaluations.length-1];

        if(this.evaluations.length === 1){
          this.compareEvaluation = this.evaluations[this.evaluations.length-1];
        }else{
          this.compareEvaluation = this.evaluations[this.evaluations.length-2];
        }
        this.evaluationLoaded = true;
        this.personalEvaluations = this.evaluations[this.evaluations.length-1].personalQuestionEvaluations;
        if(this.personalEvaluations !== null && this.personalEvaluations.length !== 0){
          this.tabs.push({
            name: 'Personenstandsdaten',
            key: 'personalQuestions',
            description: 'Übersicht über persönlichere Daten der Mitarbeitenden'
          })
        }
        this.loadingProgress = 100;
      });
    },
    remodelEvalObject(ev){
      if(ev.children != null) {
        ev.children.forEach(e => {
          this.remodelEvalObject(e);
        })
      }else{
        ev.children = [];
        ev.questionEvaluation.forEach(qEv => {
          ev.children.push({
              children: null,
              name: qEv.question.text,
              inverted: qEv.question.answerRatingInverted,
              id: qEv.question.id,
              score: qEv.answerScore,
              node: {
                name: qEv.question.text
              }
            });
          
        })
      }
    },
    getEvaluationsForTrend(ev,index){
      let otherNodes = this.evaluations.map(e => e.node[index]);
      return otherNodes.map(e => e.score);
    }, 
    getTrend(ev, indx){
      let compareToNode = this.compareEvaluation.node[indx];
      let initialNode = this.currentEvaluation.node[indx];
      return (compareToNode.score - initialNode.score).toFixed(1);
    },
    getTrendColor(score){
      if(score < 0) return 'tr_red';
      if(score > 0) return 'tr_green';
      return 'tr_yellow';
    },
    getTrendText(score){
      if(score < 0) return 'gesunken';
      if(score > 0) return 'gestiegen';
      return 'Keine Änderung';
    },
    getTrendIcon(score){
      if(score < 0) return 'mdi-trending-down';
      if(score > 0) return 'mdi-trending-up';
      return 'mdi-minus';
    },
    getProgress(data){
        let progress = 100/6 * data;
        return 100-Math.round(progress);
    },
    getColor(data){
        if(data <=2) return "var(--green-color)";
        if(data <=4) return "var(--yellow-color)";
        return "var(--red-color)";
    },
    showQuestionEvaluation(index){
      let selectedEvaluation = this.evaluations[index];
      this.selectedEvaluation = selectedEvaluation;
      this.questionEvaluation = true;
    },
    showTrendDetails(refPrefix, idx) {
      this.closePanels();
      let selectedComponent = this.$refs[refPrefix + idx];

      if (Array.isArray(selectedComponent)) {
        return selectedComponent[0].open();
      } else {
        return selectedComponent.open();
      }
    },
    changeStatisticTab(param) {
      this.currentStatisticTab = param;
    },
    timeConverter(timestamp) {
      if(timestamp == null) return " - ";
      let dt = new Date(timestamp);
      let months = ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Oct','Nov','Dez'];
      let year = dt.getFullYear();
      let month = months[dt.getMonth()];
      let date = dt.getDate();
      let time = month + ' ' + date + '. ' + year;
      return time
    },
    getAverageRate(scores) {
      let sum = 0;
      let voter = 0;
      for (let score in scores) {
        sum += score * scores[score];
        voter += scores[score];
      }
      return sum/voter
    },
    getAverageAnswer(scores) {
      if (this.getAverageRate(scores) == 6 ) return this.matrixValues[6]
      if (this.getAverageRate(scores) == 5 ) return this.matrixValues[5]
      if (this.getAverageRate(scores) == 4 ) return this.matrixValues[4]
      if (this.getAverageRate(scores) == 3 ) return this.matrixValues[3]
      if (this.getAverageRate(scores) == 2 ) return this.matrixValues[2]
      return this.matrixValues[1]
    },
    parseSurveyState(state){
      switch(state){
        case "ANSWERED":
          return "Beantwortet";
        case "SEND":
          return "Versendet";
        case "FINISHED":
          return "Beendet";
        case "CREATED":
          return "Erstellt";
      }
    },
    parseStateColor(state){
      switch(state){
        case "ANSWERED":
          return "violet";
        case "SEND":
          return "lightblue";
        case "FINISHED":
          return "lightgreen";
        case "CREATED":
          return "gray";
      }
    },
    roundToNextHalf(num){
      return Math.round(num*2)/2;
    },
    handleEvaluateQuestion(val){

      let questionEvaluation = [];
      let tmp = this.evaluations.map( (e) => ({
          timestamp : e.timestamp, 
          questionEvaluations : e.questionEvaluations
        }))
        tmp.forEach(ev => {
        let qEv = ev.questionEvaluations.find(elem => elem.questionId == val);
        questionEvaluation.push({
          timestamp: ev.timestamp,
          evalData: qEv
        });
      })
      this.closePanels();
      this.$refs["questionEvalDetail"].open(questionEvaluation);
      
    },
    closePanels(){
      for(let ref in this.$refs){
        let currRef = this.$refs[ref];
        if (Array.isArray(currRef) && currRef.length != 0) {
          currRef[0].close();
        } else if (typeof currRef == 'Object') {
          currRef.close();
        }
      }
    },
    listToMatrix() {
      var matrix = [], i, k;
      for (i = 0, k = -1; i < this.personalEvaluations.length; i++) {
        if (i % 3 === 0) {
            k++;
            matrix[k] = [];
        }

        matrix[k].push(this.personalEvaluations[i]);
      }
      return matrix;
    },
    showTreeDetails(refPrefix, idx) {
      let selectedComponent = this.$refs[refPrefix + idx];
      selectedComponent[0].showChildren = true;
      this.hideTreeDetails();
      let treeContainer = document.querySelectorAll('.tree-menu__container');
      let className = '.tree-' + idx
      let selectedTree = document.querySelectorAll(className);
      selectedTree[0].style.filter = 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.2))';
      treeContainer[idx].style.visibility = 'visible';
      // selectedComponent[0].$el.style.visibility = 'visible';

      if (Array.isArray(selectedComponent)) {
        return selectedComponent[0].open(idx);
      } else {
        return selectedComponent.open();
      }
    },
    hideTreeDetails() {
      // Initializing Tree Container
      let treeContainer = document.querySelectorAll('.tree-menu__container');
      for (let tree in treeContainer) {
        if (typeof treeContainer[tree] == 'object') {
          treeContainer[tree].style.visibility = 'hidden';
        }
      }
      // Initializing Tree Elements
      let treeContent = document.querySelectorAll('.parent-card');
      for (let el in treeContent) {
        if (typeof treeContent[el] == 'object') {
          treeContent[el].style.visibility = 'hidden';
        }
      }
      // Initializing Selected Tree
      let cards = document.querySelectorAll('#card');
      for (let card in cards) {
        if (typeof cards[card] == 'object') {
          cards[card].style.filter = 'unset';
        }
      }

    }
  }
};
</script>
<style scoped>
:deep .evaluation-info {
  padding: 12px 8px;
  min-width: 166px;
  margin-left: 10px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.04));
}
:deep .evaluation-info-title {
  font-size: 12px;
  color: var(--gray-color_3);
  font-weight: 400;
  margin: 0;
  padding: 0;
}
:deep .evaluation-info-text {
  font-size: 16px;
  color: var(--motiverse-secondary);
  font-weight: 600;
  margin: 0;
  padding: 0;
  float: right;
}
:deep .v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  -webkit-box-shadow: inset 0 4px 12px -5px rgb(50 50 50 / 15%), inset 0 -4px 12px -5px rgb(50 50 50 / 15%);
  box-shadow: inset 0 4px 12px -5px rgb(50 50 50 / 15%), inset 0 -4px 12px -5px rgb(50 50 50 / 15%);
}
.px-layout{
  height: calc(100vh - 52px);
  overflow-y: scroll;
}
.survey-title h2 {
  display: none;
}
.svg-container{
  display: flex;
  align-items: center;
}
.statistic__main__menu {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}
.statistic__main__menu--active {
  position: relative;
  width: 100%;
  height: 56px;
  color: var(--v-primary-base);
  font-weight: 600;
}
.statistic__main__menu--active span:last-child {
  background: var(--v-primary-base);
  opacity: .02;
  position: absolute;
  width: 100%;
  height: 56px;
  top: 0;
  left: 0;
}
.statistic__main__menu--active span:first-child {
  background: var(--v-primary-base);
  opacity: 1;
  position: absolute;
  width: 3%;
  height: 56px;
  top: 0;
  left: 0;
}
#clientSelect{
  width:25%;
  float:right;
}
#headerRow{
  margin: 0px 8px;
}
.dashboardFrame{
  height:95%
}
.evaluation-info {
  z-index: 9;
}
.col.col-2 {
  padding: unset;
}
.all .col {
  padding: unset;
}
#card{
  height: fit-content;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  width: 95%;
  /*white-space: nowrap;*/
}
#surveyCard{
  width:100%;
  height: 97.5%;
}
.row1{
  height:40%;
  margin: 2.5% 0;
}
.row2{
  height:45%;
  margin: 2.5% 0;
}
#cardActions{
  position: absolute;
  right: 0;
  bottom: 0;
}
#cardTitle{
  margin:5px;
  padding:0px;
  font-weight:400;
  color: var(--v-secondary-base);
}
#cardTitle h3 {
  font-size: 1.7vmin;
}
#divider{
  margin: 0 20px;
  border: 0;
  border-bottom: 1px solid var(--line-shade);
  /*background-color: var(--line-shade);*/
}
#circleFrame{
  padding: 4vh 14px 10px 14px;
  height:calc(100% - 52px - 32px);
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
}
#circle{
  margin-top:0;
  margin-bottom:0;
}
.tree-menu__container{
  padding: 20px;
  margin: 14px 52px 52px 40px;
  position: absolute;
  left: 0;
  width: calc(100vw - 104px - 40px);
  -webkit-border-radius: 10px !important;
  -moz-border-radius: 10px !important;
  border-radius: 10px !important;
}
.tree-menu__container > .tree-menu {
  display: flex;
}
.tree-menu{
  /*width: 100%;*/
  display: flex;
}
:deep .depth-1{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
}
:deep .depth-1 .child-card__container {
  min-width: 250px;
  width: 20vw;
  margin-right: 12px;
  height: fit-content;
}
:deep .depth-2 {
  margin-left: 10px;
}
:deep .depth-3 {
  margin-left: 10px;
}
.label__container {
  width: 20vw;
  margin-right: 20px;
  font-weight: 500;
}
.parent-card{
  /*width: 33vw;*/
  z-index: 99;
  visibility: hidden;
}
:deep .parent-card > .label-wrapper {
  width: 20vw;
  min-width: 20vw;
  font-size: 1.6vmin;
  font-weight: 600;
  color: var(--gray-color);
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-right: 20px;
  border-bottom: unset;
  padding-right: 20px;
  border-right: 2px solid var(--gray-color_4);
}
:deep .child-card__container > .label-wrapper {
  font-weight: 600;
  font-size: 1.4vmin;
}
:deep .depth-2 .label-wrapper {
  font-weight: 600;
  font-size: 1.4vmin;
}
:deep .depth-2 .v-icon {
  font-size: 3vmin;
}
:deep .tree-menu .v-icon {
  font-size: 3vmin;
}
:deep .v-chip__content {
  font-size: 1.5vmin;
  font-weight: 600;
}
:deep .v-chip {
  padding: 1vmin;
  height: 3.5vmin !important;
}
.parent-card {
  min-height: 20vmin;
}
div.parent-card > div {
  margin-right: 14px;
}
.has-children{
  display: flex;
}
.average-rate{
  font-size: 18px !important;
  font-weight: 500;
  text-align: center;
}
.average-answer{
  font-size: 12px;
  font-weight: 600;
  color: var(--gray-color_3);
}
.question-list__table{
  font-weight: 600;
}
.question-list__table__header{
  font-weight: 600;
  color: var(--motiverse-secondary);
}
.wrapper-inner{
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: auto;
  grid-auto-flow: row;
  align-items: stretch;
  max-width: 100%;
}
.card-detail {
  font-weight: 600;
}
@media screen and (max-width: 1440px) {
  body {
    background-color: lightblue;
  }
  .trend-test {
    padding: 0;
  }
  .trend-test div {
    padding: 2px 4px !important;
  }
  .trend-left .v-chip {
    height: 28px;
    padding: 0 6px;
  }
  .trend-left .v-chip .v-icon {
    font-size: 14px;
  }
  .trend-left span {
    font-size: 1.3vmin !important;
  }
  .card-detail {
    font-size: 1.6vmin;
  }
}
</style>